import CollaborativeQuill from './dist/collaborative_quill.js'

export default CollaborativeQuill
